import { Navigate, Route, Routes } from 'react-router-dom';

import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import { TrainerLayout } from './component/TrainerLayout';
import { FullTimeAddPage } from './page/FullTimeAddPage';
import { FullTimeDetailPage } from './page/FullTimeDetailPage';
import { FullTimePage } from './page/FullTimePage';

const TrainerRoutes = () => (
  <Routes>
    <Route element={<TrainerLayout />}>
      <Route path={PATH.TRAINER_FULL_TIME} element={<FullTimePage />} />

      <Route index element={<Navigate to={PATH.TRAINER_FULL_TIME} />} />
    </Route>
    <Route path={PATH.TRAINER_FULL_TIME_ADD} element={<FullTimeAddPage />} />
    <Route path={PATH.TRAINER_FULL_TIME_DETAIL} element={<FullTimeDetailPage />} />
    <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
  </Routes>
);

export default withPermission(['Trainers'])(TrainerRoutes);
